// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Ase3","title":"AfterFrontImage_title__TcdAc"};